import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { ClerkProvider } from "@clerk/clerk-react";

// Add custom CSS variables for the theme colors
document.documentElement.style.setProperty('--primary-color', '#2C3E50');
document.documentElement.style.setProperty('--secondary-color', '#3498DB');
document.documentElement.style.setProperty('--accent-color', '#E74C3C');
document.documentElement.style.setProperty('--neutral-color', '#ECF0F1');
document.documentElement.style.setProperty('--text-gray', '#7F8C8D');
document.documentElement.style.setProperty('--light-blue', '#EBF5FB');
document.documentElement.style.setProperty('--darker-blue', '#1A5276');

// Font families
document.documentElement.style.setProperty('--font-serif', '"Playfair Display", serif');
document.documentElement.style.setProperty('--font-sans', '"Source Sans Pro", sans-serif');

// Import Clerk publishable key from env
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Add your Clerk Publishable Key to the .env file (VITE_CLERK_PUBLISHABLE_KEY)");
}

createRoot(document.getElementById("root")!).render(
  <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
    <App />
  </ClerkProvider>
);
